module.exports = __webpack_public_path__ + "static/media/window-frame.32ad4228.svg";